import React from 'react';

import CopyRight from '@src/components/CopyRight';
import Header from '@src/components/Header';
import website from '@src/constants/website';

import MediaPlayer from './components/MediaPlayer';
import {
  ABOUT_KV_POSTER,
  ABOUT_KV_VIDEO,
  MINICLIP_LOGO,
  OUR_MISSION_TEXT,
  OUR_ORIGIN_TEXT,
  WHO_WE_ARE_TEXT,
  originStats,
} from './constant';

import './index.scss';

const About = () => {
  return (
    <div className="odc-official-page-about">
      <Header
        onLoginClick={(product: string) => {
          if (product === 'userGrowth') {
            window.location.href = website.userGrowth;
          } else if (product === 'monetization') {
            window.location.href = website.monetization;
          }
        }}
      />
      <main className="odc-about-main">
        <div className="odc-about-content">
          {/* who we are */}
          <section className="odc-about-sec">
            <h1 className="odc-about-sec-title">who we are</h1>
            <div className="odc-about-sec-body">
              <p className="odc-about-sec-text">{WHO_WE_ARE_TEXT}</p>
              <MediaPlayer
                className="odc-about-media"
                video={ABOUT_KV_VIDEO}
                poster={ABOUT_KV_POSTER}
              />
            </div>
          </section>
          {/* our origin */}
          <section className="odc-about-sec">
            <h2 className="odc-about-sec-title">Our origin</h2>
            <div className="odc-about-sec-body">
              <p className="odc-about-sec-text">{OUR_ORIGIN_TEXT}</p>
              <div className="odc-about-stats odc-about-stats-branded">
                <div className="odc-about-stats-brand">
                  <img
                    src={MINICLIP_LOGO}
                    width={175}
                    height={40}
                    alt="Miniclip"
                  />
                </div>
                <div className="odc-about-stats-row">
                  {originStats.map((item) => (
                    <div className="odc-about-stats-cell" key={item.label}>
                      <div className="odc-about-stats-value">{item.value}</div>
                      <div className="odc-about-stats-label">{item.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
          {/* our mission */}
          <section className="odc-about-sec">
            <h2 className="odc-about-sec-title">Our mission</h2>
            <div className="odc-about-sec-body">
              <p className="odc-about-sec-text">{OUR_MISSION_TEXT}</p>
            </div>
          </section>
        </div>
      </main>
      <CopyRight />
    </div>
  );
};

export default About;
